// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getStorage, connectStorageEmulator } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCMUadiNpS2vA7Mfgvdo4dS4wg0NwKhumc",
  authDomain: "cleangym.firebaseapp.com",
  projectId: "cleangym",
  storageBucket: "cleangym.appspot.com", 
  messagingSenderId: "971131253869",
  appId: "1:971131253869:web:6bbdd630d85b38bdf63b64",
  measurementId: "G-L2PDYLKHVG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// Inizializza analytics solo fuori da localhost per evitare warning in dev
let analytics = null;
if (typeof window !== "undefined" && window.location.hostname !== "localhost") {
  analytics = getAnalytics(app);
}

// --- CONFIGURAZIONE EMULATORI PER SVILUPPO LOCALE ---
if (typeof window !== "undefined" && window.location.hostname === "localhost") {
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectStorageEmulator(storage, "127.0.0.1", 9199);
}

// Export services
export { db, auth, storage, analytics };